import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ApiReferencesService } from 'src/app/services';

@Component({
  selector: 'app-directory-delete',
  templateUrl: './directory-delete.component.html',
  styleUrls: ['./directory-delete.component.css']
})
export class DirectoryDeleteComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();

  referencesId: string;
  row_id: string;
  referencesInfo: any;
  referencesCount: number;

  @Input() set data(value) {

    if (value != null) {

      this.referencesId = value.reference_id;
      this.row_id = value.row_id != null ? value.row_id : null;

     setTimeout(() => this.elementConfiramtionDelete(value.reference_id) , 500);

    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private apiReferences: ApiReferencesService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
  }


  /**
   * 
   * @param id 
   */
  elementConfiramtionDelete(id) {

    this.progressRef.start();

    let data = {
      id: id,
      mandatory: false
    }

    this.subscriptions.add(
      this.apiReferences.delete(data).subscribe(response => {
        console.log('[RESPONSE] attrInfo: ', response);

        if (response != null) {

          this.referencesInfo = response;

          for (let i of this.referencesInfo) {

            this.referencesCount = i.count;
          }

        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  refElementDelete() {

    this.activeModal.close(true);

  }

  /**
   * 
   */
  referenceDelete() {

    let data = {
      id: this.referencesId,
      mandatory: true
    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiReferences.delete(data).subscribe(response => {
        console.log('[RESPONSE] attrInfo: ', response);

        if (response != null) {

          this.activeModal.close(true); //close
        }

        this.progressRef.complete();
      })
    );
  }


  // /**
  //  * 
  //  */
  // close(data) {

  //   this.activeModal.close(data);
  // }

}
